import React, { useEffect, useState } from "react";

// you can import these packages anywhere
const LogRocket = require("logrocket");
const setupLogRocketReact = require("logrocket-react");

export default function useLogRocket() {
	function initLogRocket() {
		// only initialize when in the browser
		if (typeof window !== "undefined" && !window.location.host.includes("localhost")) {
			//Only run logRocket in Prod
			if (process.env.APP_ENV !== "production") return;
			LogRocket.init(process.env.LOG_ROCKET, {
				release: "0.1.0", //could be ENV var
				console: {
					isEnabled: false,
				},
				// network: {
				// 	requestSanitizer: (request) => {
				// 		// if the url contains 'ignore'
				// 		if (request.url.toLowerCase().indexOf("login") !== -1) {
				// 			request.body = undefined;
				// 		}

				// 		return request;
				// 	},
				// },
				// browser: {
				// 	urlSanitizer: (url) => {
				// 		let sanitizedUrl = url;

				// 		// // redact the path following /ssn/ from the URL
				// 		// sanitizedUrl = sanitizedUrl.replace(/\/ssn\/([^\/]*)/i, "/ssn/**redacted**");

				// 		// // redact the value of the query parameter secret_key
				// 		// sanitizedUrl = sanitizedUrl.replace(/secret_key=([^&]*)/, "secret_key=**redacted**");

				// 		// make sure you return the sanitized URL string
				// 		return sanitizedUrl;
				// 	},
				// },
			});
			// plugins should also only be initialized when in the browser
			setupLogRocketReact(LogRocket);
		}
	}

	function identify(user) {
		//Only run logRocket in Prod
		if (process.env.APP_ENV !== "production") return;
		if (user && LogRocket._isInitialized) {
			LogRocket.identify(user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/userid"], {
				name: user.name,
				email: user.email,
				contactNumber: user["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/contactnumber"],
			});
		}
	}
	return { initLogRocket, identify };
}
